module.exports = "images/location_health.404f9ba8f35762cbd3a785b9a8d5c3a7.png";